import { Stack, Grid, Box } from "@mui/material" 

interface IProps {
  paragraphs?: JSX.Element[]
  image?: string
}

const FormDescription = ({paragraphs, image}: IProps) => {
  return (
    <Grid container spacing={1} justifyContent={"space-between"}>
      {
        paragraphs && 
        <Grid xs={12} xl={image ? 8 : 12} item>
          <Stack sx={{color:'primary.main'}} spacing={2}>
            {paragraphs}
          </Stack>
        </Grid>
      }
      {
        image && 
        <Grid xs={4} sx={{display: {xs: 'none', sm:'none', md: 'none', lg: 'none', xl: 'block'}}} item>
          <Box 
            component={'img'}
            src={image}
            sx={{height: 130}}
          />
        </Grid>
      }

    </Grid>
  )
}

export default FormDescription